import { MessageAttachment } from "../attachments/types";
import { ParticipantOption } from "./common";
import { ChatMessage, ConversationStatus } from "./queries";

export enum ConversationType {
  DEFAULT = "DEFAULT",
  SUPPORT = "SUPPORT", // aspa
  HR = "HR",
  CUSTOMER = "CUSTOMER", // read-only: created by the customer app
}

export interface CreateConversation {
  type: ConversationType;
  participantIds: string[];
  topic?: string;
}

export interface CreateConversationThunk extends CreateConversation {
  otherParticipant?: ParticipantOption;
}

export interface CreateConversationMessage {
  id: string;
  conversationId: string;
  text: string;
}

export interface CreateConversationMessageThunk
  extends CreateConversationMessage {
  attachments?: MessageAttachment[];
  senderId?: string;
  sentAt?: string;
}

export interface ConversationAttachmentUploadUrlParams {
  conversationId: string;
  messageId: string;
  filename: string;
  size: number;
  contentType: string;
}

export interface ConversationAttachmentUploadUrl {
  url: string;
  pathspec: string;
}

export interface ConversationAttachmentDownloadUrlParams {
  conversationId: string;
  messageId: string;
  pathspec: string;
}

export interface ConversationAttachmentDownloadUrl {
  url: string;
}

export interface UpdateConversationStatus {
  conversationId: string;
  status: ConversationStatus;
}

export interface AssignConversation {
  conversationId: string;
  participantId: string;
}

export type ConversationTransferDestination =
  | { type: "TEAM"; ids: string[] }
  | { type: "EXPERT"; ids: string[] };

export interface TransferConversation {
  conversationId: string;
  destination: ConversationTransferDestination;
  notice?: string;
}

export interface AssignConversationThunk {
  conversationId: string;
}

export interface MarkConversationMessagesRead {
  conversationId: string;
  lastReadMessageId: string;
}

// COMMAND RESPONSES
export interface AssignConversationResponse {
  messageId: string;
}

export interface AssignConversationThunkResponse {
  participantId: string;
}

export interface CreateConversationResponse {
  conversationId: string;
  channel: string;
}

export interface CreateConversationMessageResponse {
  messageId: string;
}

export interface CreateConversationMessageThunkResponse {
  message: ChatMessage;
  conversationId: string;
}

export interface MarkConversationMessagesReadResponse {}
